import { createContext, useState } from 'react';

export const StoresContext = createContext();
export const StoresProvider = ({ children }) => {
    const [isCreatedStore, setIsCreatedStore] = useState(null);
    const [isEditedStore, setIsEditedStore] = useState(null);
    const [isDeletedStore, setIsDeletedStore] = useState(null);
    const [selectedStore, setSelectedStore] = useState(null);
    
    const addStore = ( value ) => { setIsCreatedStore(value) };
    const editStore = ( value ) => { setIsEditedStore(value) };
    const clearSuccess = () => {
        setIsCreatedStore(null);
        setIsDeletedStore(null)
        setIsEditedStore(null)
        setSelectedStore(null)
    }
    const setStore = ( store ) => { 
        setSelectedStore(store)
    }
    return (
        <StoresContext.Provider value={{ 
            isCreatedStore, 
            addStore, 
            clearSuccess,

            selectedStore,
            setStore,
            
            isDeletedStore,
            setIsDeletedStore,

            isEditedStore,
            editStore
            
         }}>
            {children}
        </StoresContext.Provider>
    );
};
